import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth/auth.service';
import { UserService } from '../service/user/user.service';
import { DialogService } from 'src/app/shared/genai-dialog/services/dialog.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  showPassword = false;
  email: string = '';
  password: string = '';
  errorMessage: string | null = null;

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private dialogService: DialogService
  ) { }

  loginAsUser() {

    const user = {
      email: this.email,
      password: this.password
    };
    this.authService.loginAsUser(user).subscribe({
      next: (response: any) => {
        this.userService.setTokenInfo(
          response.accessToken,
          response.refreshToken,
          response.userId,
          response.role
        );
        window.location.href = '/';
      },
      error: (err) => {
        const msg = err.error?.message || "Login failed.";
        this.dialogService.showError(msg, "Login Failed");
      }
    });
  }


  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

}
